import { useState, useContext, useEffect } from 'react';
import classNames from 'classnames';
import DealContext from '../DealContext';
import ApiService from '../../../services/ApiService';
import VehicleListItem from './VehicleListItem';
import { modal } from '../../modal/ModalEmitter';
import LoadingPage from '../../LoadingPage';

const VehicleList = () => {
  const [fetchingVehicles, setFetchingVehicles] = useState(true);
  const [vehicles, setVehicles] = useState([]);

  const { deal, quoteList } = useContext(DealContext);

  const hasUnits = vehicles.length > 0;

  const showSpecSheet = vehicleId => {
    modal.open('vehicleSpecSheet', { lookupKey: String(vehicleId) });
  };

  const fetchVehicleData = () => {
    setFetchingVehicles(true);
    return ApiService.get(`crm/deal/${deal.id}/vehicles`).then(response => {
      setVehicles(response.data || []);
      setFetchingVehicles(false);
    });
  };

  useEffect(() => {
    fetchVehicleData();
  }, []);

  useEffect(() => {
    fetchVehicleData();
  }, [quoteList]);

  if (!hasUnits && fetchingVehicles) {
    return <LoadingPage />;
  }

  return (
    <div className="vehicle-list">
      {hasUnits ? (
        vehicles.map(vehicle => {
          const quote = quoteList.find(q => q.vehicleId === vehicle.itemid);
          const className = classNames('col-lg-12', { 'col-xl-12': vehicles.length > 3 });

          if (!quote) {
            return null;
          }

          return (
            <VehicleListItem
              className={className}
              key={quote.id}
              quote={quote}
              onClick={() => showSpecSheet(vehicle.itemid)}
              vehicle={vehicle}
            />
          );
        })
      ) : (
        <div className="p-3">
          <i>Vehicles/Units involved in this deal will be displayed here.</i>
        </div>
      )}
    </div>
  );
};

export default VehicleList;
